import { License } from './licenses';

export interface BreakdownItem {
  label: string;
  value: number;
  key?: string;
}

export interface PaymentFees {
  ccFee?: number | null;
  ccTotal?: number | null;
  achFee?: number | null;
  achTotal?: number | null;
  checkFee?: number | null;
  checkTotal?: number | null;
  breakdown?: BreakdownItem[];
}

export interface PaymentSuccessInfo {
  id?: string;
  paymentConfirmation?: string;
}

export interface PaymentState {
  paymentID?: number | string | null;
  signatoryName?: string | null;
  selectedPaymentMethod?: string | null;
  paymentFees?: PaymentFees;
  paymentSuccesInfo?: PaymentSuccessInfo | null;
  paymentCheckFailed?: boolean;
  isLoading?: boolean;
  isInitialized?: boolean;
  status?: string;
}

export enum PAYMENT_PROVIDER {
  XPRESS_BILL_PAY = 'xpressbillpay',
  GENERIC = 'generic',
  STRIPE = 'stripe',
}

export type PaymentMethod = 'achDirectDebit' | 'creditOrDebitCard' | 'check';

export interface PaymentLicense {
  license: License;
  isActionable: boolean;
  isInactive: boolean;
}
export interface PaymentPeriod {
  licenses: Array<PaymentLicense>;
  startDate: Date;
  endDate: Date;
}
